// @flow

import React, { useState } from "react";
import { localize } from "redux-i18n";
import moment from "moment";
import { DatePicker, Button, ButtonGroup, Text, View } from "@components";

import { HEALTH_REPORTS_DATE_RANGES } from "@modules/reporting/constants/reports";
import type { HealthReportsDateRangesType } from "@modules/reporting/reducer/types";

type Filters = {
  selectedDataType: string,
  selectedDataTypeRange: string,
  fromDate: string,
  toDate: string,
};

type Props = $Exact<{
  ...PropsFromLocalize,
  filters: Filters,
  onSubmit: () => void,
  handleDateChange: (type: string) => void,
  handleDateRangeChange: (type: string) => void,
}>;

const HealthReportFilters = (props: Props) => {
  return (
    <>
      <ButtonGroup className="ml-4">
        <Button
          color={
            props.filters.selectedDataTypeRange === HEALTH_REPORTS_DATE_RANGES.YESTERDAY
              ? "selected"
              : null
          }
          onClick={props.handleDateRangeChange(HEALTH_REPORTS_DATE_RANGES.YESTERDAY)}
        >
          {props.t("YESTERDAY")}
        </Button>
        <Button
          color={
            props.filters.selectedDataTypeRange === HEALTH_REPORTS_DATE_RANGES.LAST_7_DAYS
              ? "selected"
              : null
          }
          onClick={props.handleDateRangeChange(HEALTH_REPORTS_DATE_RANGES.LAST_7_DAYS)}
        >
          {props.t("LAST_7_DAYS")}
        </Button>
        <Button
          color={
            props.filters.selectedDataTypeRange === HEALTH_REPORTS_DATE_RANGES.LAST_30_DAYS
              ? "selected"
              : null
          }
          onClick={props.handleDateRangeChange(HEALTH_REPORTS_DATE_RANGES.LAST_30_DAYS)}
        >
          {props.t("LAST_30_DAYS")}
        </Button>
        <Button
          color={
            props.filters.selectedDataTypeRange === HEALTH_REPORTS_DATE_RANGES.LAST_12_MONTHS
              ? "selected"
              : null
          }
          onClick={props.handleDateRangeChange(HEALTH_REPORTS_DATE_RANGES.LAST_12_MONTHS)}
        >
          {props.t("HEALTH_LAST_12_MONTHS")}
        </Button>
      </ButtonGroup>
      <View direction="row" alignItems="center" gap={4} margin={[0, 0, 0, 6]}>
        <View direction="row" alignItems="center" gap={1}>
          <Text color="charcoal" size={1}>
            {props.t("FROM_DATE")}:
          </Text>
          <DatePicker
            value={props.filters.fromDate}
            onChange={props.handleDateChange("fromDate")}
            id="care-plans-from-date"
          />
        </View>

        <View direction="row" alignItems="center" gap={1}>
          <Text color="charcoal" size={1}>
            {props.t("TO_DATE")}:
          </Text>
          <DatePicker
            value={props.filters.toDate}
            onChange={props.handleDateChange("toDate")}
            id="care-plans-to-date"
            maxDate={
              props.filters.fromDate
                ? moment(props.filters.fromDate, "YYYY-MM-DD")
                    .add(1, "year")
                    .format("YYYY-MM-DD")
                : null
            }
          />
        </View>
        <Button
          materialIcon="replay_circle_filled"
          onClick={props.onSubmit}
          disabled={!props.filters.fromDate || !props.filters.toDate}
        >
          {props.t("SUBMIT")}
        </Button>
      </View>
    </>
  );
};

export default localize()(HealthReportFilters);
